import { defineComponent as _defineComponent } from 'vue'
import { required } from '@vuelidate/validators';
import { makeFormModel, submitForm } from 'ah-common-lib/src/form/helpers';
import { FormEvent } from 'ah-common-lib/src/form/interfaces';
import { email } from 'ah-common-lib/src/form/validators';
import { reactive, ref } from 'vue';
import { useTheme } from 'ah-theme';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgottenPasswordView',
  setup(__props) {

const theme = useTheme();

const requestManager = useRequestManager().manager;

const services = getServices();

const forgottenPasswordForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'ForgottenPasswordForm',
    fieldType: 'form',
    fields: [
      {
        name: 'email',
        title: 'Email',
        fieldType: 'text',
        errorMessages: {
          required: 'Email is required',
        },
        validators: {
          required,
          email,
        },
      },
    ],
  }),
  validation: null,
});

const emailSent = ref<boolean>(false);

function onFormEvent(formEvent: FormEvent) {
  if (formEvent.event === 'form-field-submit') {
    submit();
  }
}

function supportEmail() {
  theme.val?.helpEmail;
}

function submit() {
  if (forgottenPasswordForm.validation?.$invalid) {
    submitForm(forgottenPasswordForm.validation);
    return;
  }

  const payload = { email: forgottenPasswordForm.form.email };

  requestManager.sameOrCancelAndNew('resetPassword', services.account.resetPassword(payload), payload).subscribe(() => {
    emailSent.value = true;
  });
}

return { __sfc: true,theme, requestManager, services, forgottenPasswordForm, emailSent, onFormEvent, supportEmail, submit, email }
}

})